'use client';

import { cn } from '@workspace/ui/lib';
import { CircleHelp } from 'lucide-react';
import { appTopHeaderActionSurfaceClassName } from './app-top-header';

export const HELP_DESK_URL = 'https://help.nativeteams.com/' as const;

interface AppTopHeaderHelpDeskProps {
  label: string;
}

export function AppTopHeaderHelpDesk({ label }: AppTopHeaderHelpDeskProps) {
  return (
    <a
      href={HELP_DESK_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        appTopHeaderActionSurfaceClassName,
        'inline-flex h-[30px] items-center gap-2 rounded-full px-3.5'
      )}
    >
      <CircleHelp className="size-4 shrink-0 stroke-[1.75]" aria-hidden="true" />
      <p className="m-0 text-sm leading-none whitespace-nowrap">{label}</p>
    </a>
  );
}
